/* eslint-disable import/prefer-default-export */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useE911Numbers = () => {
  const numbersDoc = useSelector(state => state.AppState.numbers);

  const numbers = useMemo(() => {
    const { allNumbers: numbers_ } = numbersDoc || {};
    return numbers_;
  }, [numbersDoc]);

  return numbers;
};
